import { CREATE_RECEVING,  CLOSE_RECEVING, UPDATE_RECEVING_ITEM, DELETE_RECEVING_ITEM, CLOSE_DEFINITIVE_RECEIVING } from "../../ActionType/ActionType"


export const createNewReceivingAction=({receiving, callback=null})=>{
    return async (dispatch , getState, {getFirebase})=>{
        dispatch({type: CREATE_RECEVING.REQUEST})

        try {
          var received =  await getFirebase().firestore().collection('received_orders').add({...receiving, ActivityStatus :'Open'})

          await getFirebase().firestore().collection('shipping_orders')
                    .doc(receiving.ShippingId).set({ActivityStatus : "Received", ReceivedId : received.id, updateAt: new Date()}, {merge : true})

            dispatch({type: CREATE_RECEVING.SUCCESS})
            if( callback !== null){
                callback()
            }
        } catch (error) {
            dispatch({type: CREATE_RECEVING.FAILURE, error : error})
        }
    }
}

export const closeReceivingAction=({ShippingId, receivingId, callback=null})=>{
    return async (dispatch , getState, {getFirebase})=>{
        dispatch({type: CLOSE_RECEVING.REQUEST})

        try {
          await getFirebase().firestore().collection('received_orders')
                            .doc(receivingId).set({isOpen : false}, {merge : true})
          await getFirebase().firestore().collection('shipping_orders')
                    .doc(ShippingId).set({ReceivedId : null, updateAt: new Date()}, {merge : true})

            dispatch({type: CLOSE_RECEVING.SUCCESS})
            if( callback !== null){
                callback()
            }
        } catch (error) {
            dispatch({type: CLOSE_RECEVING.FAILURE, error : error})
        }
    }
}


export const UpdateReceivingItemAction=({receivingId, Receiving, callback=null})=>{
    return (dispatch , getState, {getFirebase})=>{
        dispatch({type: UPDATE_RECEVING_ITEM.REQUEST})

        const db = getFirebase().firestore();

        var sfDocRef = db.collection("received_orders").doc(receivingId);

        db.runTransaction((transaction) => {
            return transaction.get(sfDocRef).then((sfDoc) => {

                if (sfDoc.exists) {
                    var newReceivingItem  = sfDoc.data().ReceivedItems;
                    let FiltItem = newReceivingItem.filter(it =>it.ItemId !== Receiving.ItemId)
                    let FnewReceivingItem = [...FiltItem, {...Receiving}]
                    transaction.update(sfDocRef, {ReceivedItems : FnewReceivingItem});
                    
                }
        

            });
        }).then(() => {
            dispatch({type: UPDATE_RECEVING_ITEM.SUCCESS})
            if( callback !== null){
                callback()
            }
            console.log("Transaction successfully committed!");
        }).catch((err) => {
            console.error(err);
            dispatch({type: UPDATE_RECEVING_ITEM.FAILURE, error : err})
        });
    }
}


export const DeleteReceivingItemAction=({receivingId, Receivings, callback=null})=>{
    return async (dispatch , getState, {getFirebase})=>{
        dispatch({type: DELETE_RECEVING_ITEM.REQUEST})


        const db = getFirebase().firestore();

        var sfDocRef = db.collection("received_orders").doc(receivingId);

        db.runTransaction((transaction) => {

            return transaction.get(sfDocRef).then((sfDoc) => {
                if (sfDoc.exists) {
                   let newReceivingItem = sfDoc.data().ReceivedItems;
                    Receivings.forEach(rec => {
                        newReceivingItem = newReceivingItem.filter(it =>it.ItemId !== rec.ItemId)
                    });                   
                    transaction.update(sfDocRef, {ReceivedItems : newReceivingItem});
                }
            });

        }).then(() => {
            dispatch({type: DELETE_RECEVING_ITEM.SUCCESS})
            
            if( callback !== null){
                callback()
            }

        }).catch((err) => {
            console.error(err);
            dispatch({type: DELETE_RECEVING_ITEM.FAILURE, error : err})
        });

    }
}

export const DefinitifCloseShipping=({ShippingId, callback=null})=>{
    return async (dispatch, getState, {getFirebase}) =>{
        dispatch({type : CLOSE_DEFINITIVE_RECEIVING.REQUEST})

        const db = getFirebase().firestore()
        try { 

            var sfDocRef =  db.collection("shipping_orders").doc(ShippingId);
            
            db.runTransaction((transac)=>{
                return transac.get(sfDocRef).then((sfDoc)=>{
                    if(sfDoc.exists){
                        transac.update(sfDocRef, {ActivityStatus : 'Closed'})
                    }
                })
            })
            
            let receivedsSnap = await db.collection("received_orders").where('ShippingId', '==', ShippingId).get()
            
            receivedsSnap.forEach(async(doc)=>{
               if(doc.exists){
                  await db.collection("received_orders").doc(doc.id).set({ActivityStatus : "Closed"},{merge: true})
               }
            })

            dispatch({type : CLOSE_DEFINITIVE_RECEIVING.SUCCESS})
            if(callback !== null){
                callback()
            }
            
        } catch (error) {
            dispatch({type : CLOSE_DEFINITIVE_RECEIVING.FAILURE})
            console.log(error)
        }

    }
}